import React, { useState, useEffect } from "react"
import { cn, ELEMENTS, randoms } from "lib/utils"
import { RenderLayout } from "lib/components"
import { BuilderModal, LayoutBuildBlock, useLayoutBuilder } from "."


export default function LayoutBuilder({
  layout
}:{
  layout:any
}){

  const [ workingLayout, setWorkingLayout ] = useState<any>(layout || [])
  const [ selectedElement, setSelectedElement ] = useState<any>(null)

  const { layoutBldrTools }:any = useLayoutBuilder(workingLayout, setWorkingLayout, selectedElement, setSelectedElement)
  const { addToLayout, assignElement }:any = layoutBldrTools

  const blocktypes = [
    { refstr: "horiz-stack", label: "Horiz Stack", type: "hstack" },
    { refstr: "vert-stack", label: "Vert Stack", type: "vstack" },
    { refstr: "element", label: "Element", type: "element" },
    { refstr: "--", label: "Save", type: "--" },
  ]


  // useEffect(() => {
  //   console.log(workingLayout)
  // },[workingLayout])

  return (
    <div className="w-full h-[calc(100vh-23rem)] flex flex-col items-stretch relative gap-5">
      <div className="w-full h-[43rem] flex flex-col border border-solid border-slate-700 p-3 relative overflow-y-auto">
        <div 
          onDragOver={ (e:any) => {
            e.preventDefault()
            e.dataTransfer.dropEffect = "move"
          }}
          onDrop={(e:any) => {
            console.log("dropped")
            e.preventDefault()
            e.stopPropagation()
            const type = e.dataTransfer.getData("type")
            addToLayout(type)
          }}
          className="w-full h-[calc(100%-48px)] flex flex-col relative"
        >
          <BuilderModal 
            open={selectedElement} 
            closeFn={() => setSelectedElement(null)}
            selectedElement={selectedElement}
            selectFn={assignElement}
          />

          <RenderLayout 
            layout={workingLayout.config.structure} 
            mode="build" 
            editable={true} 
            handleWireframeClick={(refstr:any) => setSelectedElement(refstr)}
            layoutBldrTools={layoutBldrTools}
          />
        </div>
      </div>

      <div className="absolute bottom-[2px] left-[2px] w-[calc(100%-4px)] h-12 flex justify-center items-center gap-5 bg-slate-700 p-2">
        { blocktypes.map( (block:any) => (
          <LayoutBuildBlock 
            key={block.refstr} 
            label={block.label} 
            type={block.type} 
            workingLayout={workingLayout}
            layoutBldrTools={layoutBldrTools}
          />
      ))}
      </div>
    </div>
  )
}